<dx-popup
    #uploadInvoicePopup
    minWidth="150px"
    minHeight="150px"
    width="20%"
    height="20%"
    title="Upload Invoice"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupClose()"
>
    <div id="uploadInvoiceBox" *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-file-uploader
                        selectButtonText="Browse..."
                        accept="*"
                        uploadMode="useForm"
                        labelText=""
                        accept="application/pdf"
                        [elementAttr]="{ class: 'field-component' }"
                        [multiple]="false"
                        [(value)]="uploadedFile"
                        (onValueChanged)="onFileUpload($event)"
                    ></dx-file-uploader>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="button-container">
                        <div class="left-content">
                            <dx-button
                                type="default"
                                text="Cancel"
                                hint="Cancel"
                                [icon]="iconCancel"
                                (onClick)="onCancelClick()"
                            ></dx-button>
                        </div>
                        <div class="right-content">
                            <dx-button
                                type="success"
                                text="Submit"
                                hint="Submit"
                                [icon]="iconCheck"
                                (onClick)="onSubmitClick()"
                            ></dx-button>
                        </div>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#uploadInvoiceBox' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
